@for (reference of references(); track reference.id) {
  <tt-reference [reference]="reference" />
}
